import React, { useContext } from "react";
import styled from "styled-components";
import ActionsContext from "common/ActionsContext";
import View from "common/View";
import InstallSoftware from "./Install";
import SoftwareAdminHelp from "./Help";
import SoftwareList from "./SoftwareList";

const ExtraMenuWrapper = styled.div`
  margin: 0 0 20px;
`;

const options = [
  {
    signal: "install-software",
    label: "Install",
  },
];

export const SoftwareAdmin = () => {
  const actions = useContext(ActionsContext);
  return (
    <View
      title="Software Packages"
      className="container-lg"
      options={options}
      Help={SoftwareAdminHelp}
    >
      <ExtraMenuWrapper>
        <button
          type="button"
          className="btn btn-default waves-effect shadow-none hidden-to-operators"
          onClick={() => actions.send("install-software")}
        >
          <i className="material-icons">add_circle</i>
          <span>Install new package...</span>
        </button>
      </ExtraMenuWrapper>
      <SoftwareList />
      <InstallSoftware />
    </View>
  );
};

export default SoftwareAdmin;
